import React from 'react';

import classNames from 'classnames'

import {withStyles} from '@material-ui/core/styles/index';
import {withRouter} from 'react-router-dom';

import Typography from '@material-ui/core/Typography';

const styles = () =>
({
    root :
    {
        display    : 'flex',
        alignItems : 'center'
    },
    logo     : {} ,
    logoIcon :
    {
        width : 38,
        height: 38
    }
});

const logo = 'assets/images/logos/ooopener.svg' ;

function NavbarHeader({classes})
{
    return (
        <div className={classes.root}>
            <div className={classNames(classes.logo, "flex items-center")}>
                <img className={classes.logoIcon} src={logo} alt="logo"/>
                <Typography className="text-20 ml-8 font-light logo-text">XYZ</Typography>
            </div>
        </div>
    );
};

export default withStyles( styles , { withTheme: true } )( withRouter(NavbarHeader) );



// WEBPACK FOOTER //
// ./src/app/display/NavbarHeader.js